import { Badge } from '@/components/ui/catalyst/badge';

import { TIME_ZONES } from '../../utils/constants';
import { DepartmentFormData } from './types';

interface DepartmentSidebarViewProps {
  formData: DepartmentFormData;
  onEdit: () => void;
}

export const DepartmentSidebarView = ({
  formData,
  onEdit,
}: DepartmentSidebarViewProps) => {
  const timeZoneLabel = formData.timeZone
    ? TIME_ZONES.find((t) => t.value === formData.timeZone)?.label ||
      formData.timeZone
    : null;

  return (
    <>
      <div className="space-y-2.5">
        {formData.description && (
          <p className="text-sm leading-relaxed text-gray-600">
            {formData.description}
          </p>
        )}

        <div className="flex flex-wrap gap-1.5">
          {timeZoneLabel && (
            <Badge color="zinc" className="text-xs font-normal">
              {timeZoneLabel}
            </Badge>
          )}

          {formData.doNotCall && (
            <Badge color="amber" className="text-xs font-normal">
              Calling disabled
            </Badge>
          )}
        </div>
      </div>

      <button
        type="button"
        onClick={onEdit}
        className="mt-4 w-full border-t pt-3 text-center text-xs font-medium text-gray-400 transition-colors hover:text-gray-600"
      >
        Edit
      </button>
    </>
  );
};
